// This file shared with My Account and Blog

import "@/styles/interproject.scss"
import { register } from "../helpers/stimulus"

import { setupTabs } from "@/components/tabs"
import { setupAccordions } from "@/components/content/Accordion"
import { setupNavbar } from "@/components/navbar"
import { setupFooter } from "@/components/footer"

import InterprojectController from "../controllers/interproject_controller"

register("interproject", InterprojectController)

setupAccordions()
setupTabs()
setupNavbar()
setupFooter()
